import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiPost } from '@/lib/api';

export function useCancelAudit(id: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiPost<void>(`/v1/audits/${id}/cancel`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['audit', id] });
      void qc.invalidateQueries({ queryKey: ['audits'] });
    },
  });
}
